export default __webpack_public_path__ + "static/media/ericGarner.e45b0b66.png";